import React from "react";
import { Link } from "react-router-dom";
import PlantImage from "../../components/fancyplants/PlantImage";
import Seo from "../../components/fancyplants/Seo";
import { SITE_IMAGES } from "../../data/siteImages";

export default function NotFoundPage() {
  return (
    <div className="container-fp flex min-h-[70vh] flex-col items-center justify-center py-24 text-center">
      <Seo title="Page not found" noindex />
      <div className="mb-8 w-full max-w-lg overflow-hidden rounded-3xl">
        <PlantImage
          src={SITE_IMAGES.emptyState}
          alt=""
          ratio="16/9"
          priority
        />
      </div>
      <p className="font-display text-7xl text-brass">404</p>
      <h1 className="t-h2 mt-4">This page has gone to seed.</h1>
      <p className="t-lead mt-3 max-w-md">
        We couldn't find what you were looking for — but there are plenty of healthy things in the shop.
      </p>
      <div className="mt-6 flex gap-3">
        <Link to="/shop" className="btn-brass">Browse the shop</Link>
        <Link to="/" className="btn-outline">Back home</Link>
      </div>
    </div>
  );
}
